import sortBy from "lodash/sortBy";
/**
 * Picks the most appropriate badge to display from a list of badges, based of
 * their priorities and positions.
 */ export var selectBadge = function(badges, position) {
    var sortedValidBadges = sortBy(badges === null || badges === void 0 ? void 0 : badges.filter(function(badge) {
        var _badge_style, _badge_style1;
        return badge.display_to_user && ((_badge_style = badge.style) === null || _badge_style === void 0 ? void 0 : _badge_style.badge_message) && (!position || position === ((_badge_style1 = badge.style) === null || _badge_style1 === void 0 ? void 0 : _badge_style1.position));
    }), function(b) {
        var _b_priority;
        return -((_b_priority = b.priority) !== null && _b_priority !== void 0 ? _b_priority : 0);
    });
    return sortedValidBadges[0];
};
